import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, FormGroup, Label, Input, Spinner, Modal,
  ModalHeader,
  ModalBody } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComprasCreateInt() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  
  const URL_COMPRAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_ACUMULADOS;

  const [embarques, setEmbarques] = useState([]);
  const [selectedEmbarque, setSelectedEmbarque] = useState([]);  
  const [selectedProveedor, setSelectedProveedor] = useState("");  
  
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [colores, setColores] = useState([]);

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [total_rollos, setTotalRollos] = useState(0);
  const [totalDin, setTotalDin] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(0);

  const [articulosEmbarque, setArticulosEmbarque] = useState([]);
  const [fecha_embarque, setFechaEmbarque] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");

  const [totalCaptura, setTotalCaptura] = useState(1);
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosEmbarque:"",
      articulosOC:"",
      articulos: "",
      unidad: "",
      colores: "",
      cantidad: 0,
      clave:"0",
      captura:1,
      costo:0,
      total:0,
      articulosName: "",
      coloresName: "",
      rollos: parseFloat(1),
      proveedores:""
    },
  ]);

  const [inputFields2, setInputFields2] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
    .get(URL_EMBARQUES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allEmbarques = res.data;
      setEmbarques(allEmbarques);
    })
    .catch((err) => {
      console.log(err);
    });
    
      axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    
    
  }, []);


  const saveCompraNueva = async (event) => {
    event.preventDefault();
    if (fecha != "" && observaciones != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields2.length + cantidadAgrupado.length + cantidadAgrupado.length
      try {
        await axios
        .post(
          URL_COMPRAS,
          {
            fecha,
            embarques: selectedEmbarque,
            observaciones,
            total_kilos,
            total_metros: total_metros.toFixed(2),
            user: user.id,
            tipo:"Internacional",
            pais_origen:"China",
            total_costo:0,
            saldo:0,
            factura_proveedor:"NA",
            proveedores: selectedProveedor
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
          .then((data) => {


            axios
              .post(
                `${URL_NOTAS_CXP}`,
                {
                  proveedores: selectedProveedor,
                  embarques: selectedEmbarque,
                  compras: data.data._id,
                  total_cantidad: total_metros.toFixed(2),
                  total_costo: (totalDin * tipoCambio).toFixed(2),
                  saldo: (totalDin * tipoCambio).toFixed(2),
                  calidad: "No",
                  fecha,
                  tipoCambio,
                  totalUSD: totalDin.toFixed(2)
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )

            inputFields2.map((a) => {
              if (a.articulos != "" && a.cantidad !=0) {
                axios.post(
                  URL_INVENTARIOS,
                  {
                    compras: data.data._id,
                    articulos: a.articulos,
                    articulosEmbarques: a.articulosEmbarque,
                    articulosOC: a.articulosOC,
                    colores: a.colores,
                    cantidad: parseFloat(a.cantidad),
                    cantidadFacturada: parseFloat(a.cantidad),
                    clave: a.clave,
                    captura: a.captura,
                    proveedores: a.proveedores,
                    costoUSD: a.costo,
                    tipoCambio,
                    costo: a.costo * tipoCambio,
                    proveedores: selectedProveedor,
                    unidad: a.unidad,
                    unidadFacturada: a.unidad,    
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios.post(
                        URL_LOGS,
                        {
                          tipo: "Crear Compra",
                          detalle: `Embarque ${selectedEmbarque}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                          },
                        }
                      )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Compra",
                      detalle: `Embarque ${selectedEmbarque}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                      },
                    }
                  )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
            cantidadAgrupado.map((w) => {
              axios
                .patch(
                  `${URL_ARTICULOS_EMBARQUES}editEmbarcado/${w.articulosEmbarque}`,
                  {
                    cantidad: w.cantidad,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Crear Compra",
                        detalle: `Embarque ${selectedEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Pegamos a Compras Acumulado

            cantidadAgrupado.map((w) => {
              axios
                .post(
                  `${URL_COMPRAS_ACUMULADOS}`,
                  {
                    fecha,
                    compras: data.data._id,
                    articulos: w.articulos,
                    articulosEmbarques: w.articulosEmbarque,
                    colores: w.colores,
                    cantidad: w.cantidad,
                    embarques: selectedEmbarque, 
                    precio: w.costo * tipoCambio,
                    precioUSD: w.costo,
                    tipoCambio,
                    proveedores: selectedProveedor,
                    total: (w.costo * tipoCambio) * w.cantidad
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Crear Compra",
                        detalle: `Embarque ${selectedEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Terminamos de post a compras acumulado
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };


  const handleAddFields = () => {
    let TC = totalCaptura +1
    const ultimo = inputFields[inputFields.length-1];
    
    setTotalCaptura(TC)
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulosEmbarque: ultimo.articulosEmbarque,
        articulosOC: ultimo.articulosOC,
        articulos: ultimo.articulos,
        unidad:ultimo.unidad,
        colores: ultimo.colores,
        cantidad: 0,
        clave: ultimo.clave,
        captura:TC,
        costo:ultimo.costo,
        total:0,
        articulosName: ultimo.articulosName,
        coloresName: ultimo.coloresName,
        rollos: parseFloat(1),
        proveedores: ultimo.proveedores
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter(e=>e.unidad == "Metros")
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter(e=>e.unidad == "Kilos")
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };
console.log("hola2", tipoCambio, totalDin)
console.log("hola3", cantidadAgrupado)
  // const handleChangeInputCantidad = (id, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i[event.target.name] = parseFloat(event.target.value);
  //       i.total = parseFloat(event.target.value) * parseFloat(i.costo)
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);
  //   ActualizaTotales()
  // };

  function BuscaArticulo(id, event){
    articulosEmbarque.map((a)=>{
      if(a._id == event.target.value){
        let articulosEmbarque = a._id
        let articulosOC = a.articulos[0]._id
        let idArticulo = a.articulos[0]._id
        let unidadArticulo = a.articulos[0].unidad
        let color = a.articulosOC[0].colores[0]._id
        let costo = a.costo
        let articulosName = a.articulos[0].nombre
        let coloresName = a.articulosOC[0].colores[0].name
        let proveedor = a.articulosOC[0].ordenesCompra[0].proveedores[0]._id
        handleChangeInputArticulo(id, articulosEmbarque, articulosOC, idArticulo, unidadArticulo, color, costo, articulosName, coloresName, proveedor)
      }
    })
  }

  const handleChangeInputArticulo = (id, articulosEmbarque,  articulosOC,  idArticulo, unidadArticulo, color, costo, articulosName, coloresName, proveedor) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulosEmbarque = articulosEmbarque
        i.articulosOC = articulosOC
        i.articulos = idArticulo
        i.unidad = unidadArticulo
        i.colores = color
        i.costo = costo
        i.articulosName = articulosName
        i.coloresName = coloresName
        i.proveedores = proveedor
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
    
  };

  function ActualizaTotales(){
        let mts = inputFields2.filter(e=>e.unidad == "Metros")
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetros(TM);
        let KG = inputFields2.filter(e=>e.unidad == "Kilos")
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilos(TK);


        let totalRollos = inputFields2.map((c) => parseFloat(c.rollos));
        let Rollos = totalRollos.reduce((t, total, index) => t + total, 0);
        setTotalRollos(Rollos);

        let totalDin = inputFields2.map((c) => parseFloat(c.total));
        let Din = totalDin.reduce((t, total, index) => t + total, 0);
        setTotalDin(Din);

        let agrupado = inputFields2.reduce(function (groups, item) {
          const val = item["articulos"] + item["colores"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            colores: item.colores,
            cantidad: 0,
            total:0,
            rollos:0
          };
          groups[val].cantidad += item.cantidad;
          groups[val].rollos += item.rollos;
          groups[val].total += item.total;
          groups[val].id = item.id;
          groups[val].articulos = item.articulos;
          groups[val].articulosName = item.articulosName;
          groups[val].coloresName = item.coloresName;
          groups[val].unidad = item.unidad;
          groups[val].colores = item.colores;
          groups[val].clave = item.clave;
          groups[val].costo = item.costo;
          groups[val].articulosEmbarque = item.articulosEmbarque;
          return groups;
        }, []);
    
        let CA = Object.values(agrupado);
        setCantidadAgrupado(CA);
  }


  function jalaEmbarque(e){
    setSelectedEmbarque(e)
    
    axios
    .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${e}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allArticulosEmbarque = res.data;
      setArticulosEmbarque(allArticulosEmbarque);
    })
    .catch((err) => {
      console.log(err);
    });

    embarques.map((a)=>{
      if(a._id == e){
        setFechaEmbarque(a.fechaEmbarque)
        setFechaCompromiso(a.fechaEstimada)
        setSelectedProveedor(a.proveedores[0]._id)
      }
    })
  }

  function importarArchivo(inputField, event){
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];
   
    if (name === "file") {
  
      let reader = new FileReader();
        reader.readAsArrayBuffer(target.files[0]);
        reader.onloadend = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });
  
          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_json(
              workbook.Sheets[sheetName]
            );
            hojas.push({
              data: XL_row_object,
              sheetName,
            });
          });
  
          let A1 = hojas[0].data
  
          let TC = totalCaptura
          A1.map((a)=>{
             TC = TC + 1
            setTotalCaptura(TC)
          inputFields2.push({
            id: uuidv4(),
            articulosOC: inputField.articulosOC,
            articulosEmbarque: inputField.articulosEmbarque,
            articulos: inputField.articulos,
            unidad:inputField.unidad,
            colores: inputField.colores,
            cantidad: a.cantidad,
            clave: inputField.clave,
            captura:TC,
            costo:inputField.costo,
            total: parseFloat(a.cantidad) * parseFloat(inputField.costo),
            articulosName: inputField.articulosName,
            coloresName: inputField.coloresName,
            rollos: parseFloat(1),
            proveedores: inputField.proveedores,
          })
          })
  
          ActualizaTotales()
        }
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.compras_create ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Compra</h3>
          <Form onSubmit={saveCompraNueva}>
            <Row>
            <Col md={2}>
                <Label className="mr-sm-2">Embarque</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmbarque}
                  required
                  onChange={(e) => jalaEmbarque(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {embarques
                    .sort((a, b) => (a.idEmbarques < b.idEmbarques ? 1 : -1))
                    .map((a) => {
                      if(a.recibido == "No" && a.is_active == "Si"){
                      return <option value={a._id}>{a.idEmbarques} / {a.contenedor}</option>}
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Fecha Embarque</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_embarque}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaEmbarque(e.target.value);
                  }}
                />
              </Col>
            
              <Col md={2}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha Compromiso"
                  value={fecha_compromiso}
                  required
                  disabled
                />
              </Col>
            <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
             
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>T.C.</Label>
                <Input
                  type="number"
                  value={tipoCambio}
                  required
                  onChange={(e) => {
                    setTipoCambio(e.target.value);
                  }}
                />
              </Col>
              </Row>


                    <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Rollos</Label>
                </Col>
              </Row>
                {cantidadAgrupado.map((ag)=>{
                  return (
                    <>
                    <Row>
                    <Col md={2}>
                    <Label className="mr-sm-2">{ag.articulosName}</Label>
                      </Col> 
                    <Col md={2}>
                    <Label className="mr-sm-2">{ag.coloresName}</Label>
                      </Col>
                    <Col md={2}>
                    <Label className="mr-sm-2">{(ag.cantidad).toFixed(2)}</Label>
                      </Col> 
                    <Col md={2}>
                    <Label className="mr-sm-2">{ag.rollos}</Label>
                      </Col> 
                    </Row>
                    </>
                    )
                })}



              <Row>
              <Col md={12}>
              <h4 id="logoutBoton">
              TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)} kg. / {new Intl.NumberFormat("en-US").format(total_metros)} mts. / {new Intl.NumberFormat("en-US").format(total_rollos)} rollos
              </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}

              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Clave</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Archivo</Label>
                </Col>
              </Row>

              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={4}>
                      <Input
                        bsSize="sm"
                        name="articulos"
                        type="select"
                        value={inputField.articulosEmbarque}
                        required
                        onChange={(event)=>{BuscaArticulo(inputField.id, event)}}
                      >
                        <option value="">Selecciona un Articulo</option>
                        {articulosEmbarque
                          .sort((a, b) => (a.articulos[0].nombre < b.articulos[0].nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.articulos[0].nombre} / {a.articulosOC[0].colores[0].name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                         bsSize="sm"
                          name="unidad"
                          type="string"
                          value={inputField.unidad}
                          disabled
                        >
                        </Input>
                      </Col>

                      
                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="clave"
                        type="text"
                        placeholder="Clave"
                        value={inputField.clave}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(inputField, event)
                      }
                    />
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFields.length === 1}
                        onClick={() => handleRemoveFields(inputField.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1">
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
              <Col md={12}>
              <h4 id="logoutBoton">
              TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)} kg. / {new Intl.NumberFormat("en-US").format(total_metros)} mts. / {new Intl.NumberFormat("en-US").format(total_rollos)} rollos
              </h4>
              </Col>
              </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoComprasInt"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
       <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios minutos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasCreateInt;
